import axios from "axios";
import { vectorizeFormulaList } from "./namespace";

export async function getVectorData(formulaList: string[]) {
    try {
        const _res = await axios.post(vectorizeFormulaList, {
            list: formulaList
        });
        if (!_res || !_res.data) {
            throw new Error("Error in getVectorData: No response from server");
        }
        return {
            output:_res.data[0].output,
            highRanked:_res.data[0].highRanked,
        };
    } catch (error: any) {
        throw new Error("Error in getVectorData: " + error.messages);
    }
}